export default __webpack_public_path__ + "static/gilroy-bold-e80224c1465a84679b976a39ea70900a.ttf";